import {Alignments} from '../types/galleryTypes';

export enum alignItems {
  Center = 'center',
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
}

/* istanbul ignore next */
export const getFlexAlignment = (alignment: Alignments, isRTL: boolean) => {
  switch (alignment) {
    case Alignments.LEFT:
      return isRTL ? alignItems.FlexEnd : alignItems.FlexStart;
    case Alignments.RIGHT:
      return isRTL ? alignItems.FlexStart : alignItems.FlexEnd;
    case Alignments.CENTER:
      return alignItems.Center;
  }
};
